import classNames from 'classnames';
import ProgressBar from 'components/ProgressBar';
import ProjectBadge from 'components/projects/ProjectBadge';
import React from 'react';
import { Card } from './Card';
import styles from './ProjectCard.module.scss';

interface Props {
  className?: string;
}
export const PlaceholderProjectCard = (props: Props) => {
  const containerClass = classNames(
    styles.projectCard,
    styles.placeholderProjectCard,
    props.className
  );

  return (
    <Card className={containerClass}>
      <div className={styles.cardBlocks}>
        <div className={styles.heading}>
          <ProjectBadge className={styles.badge} size="large" icon color="#ccc" />
          <div className={styles.placeholderHeading} />
          <div className={styles.placeholderParagraph} />
        </div>
        <div className={styles.footer}>
          <div className={styles.budget}>
            <ProgressBar size="small" value={0} />
            <div className={styles.label}>
              <div className={styles.placeholderParagraph} />
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
